import { Segmented } from "antd";
import { useEffect, useState } from "react";
import CypressTestIds from "../../../cypress/CypressTestIds";

interface ISchemaModelCreateOptionsProps {
    selectedOption: ISchemaCreationType;
    onOptionSelected: (option: ISchemaCreationType) => void;
}

const SchemaModelCreateOptions = ({ selectedOption, onOptionSelected }: ISchemaModelCreateOptionsProps) => {
    const [selectedButton, setSelectedButton] = useState<ISchemaCreationType>(selectedOption);

    useEffect(() => {
        setSelectedButton(selectedOption);
    }, [selectedOption]);

    const onCreateOptionClick = (option: ISchemaCreationType) => {
        setSelectedButton(option);
        onOptionSelected && onOptionSelected(option);
    };

    return (
        <Segmented<ISchemaCreationType>
            value={selectedButton}
            onChange={(value) => onCreateOptionClick(value)}
            options={[
                {
                    value: "CREATE_FROM_FILE",
                    label: <div data-testid={CypressTestIds.CREATE_NEW_SCHEMA_FROM_FILE_BUTTON}>Create from a file</div>,
                },
                {
                    value: "CREATE_MANUALLY",
                    label: <div data-testid={CypressTestIds.CREATE_NEW_SCHEMA_MANUALLY_BUTTON}>Define fields manually</div>,
                },
                {
                    value: "CLONE_EXISTING_SCHEMA",
                    label: <div data-testid={CypressTestIds.CREATE_NEW_SCHEMA_CLONE_BUTTON}>Clone an existing schema</div>,
                },
                {
                    value: "CREATE_FROM_SYSTEM_CONNECTION",
                    label: <div data-testid={CypressTestIds.CREATE_NEW_SCHEMA_FROM_SYSTEM_CONNECTION_BUTTON}>Create from system connection</div>,
                },
            ]}
        />
    );
};

export default SchemaModelCreateOptions;
